<template>
  <ag-modal-container
    :value="visible"
    :title="$t('animation.title.addSession')"
    width="600px"
    @close="close"
  >
    <template v-if="openableSessionList.length">
      <v-text-field
        v-model="search"
        :placeholder="$t('general.search')"
        prepend-icon="mdi-magnify"
      />
      <v-list v-if="sessionList.length">
        <template v-for="(session, index) in sessionList">
          <v-divider v-if="index" :key="index" />
          <v-list-item
            :key="session.id"
            link
            @click="toggleSessionSelect(session.id)"
          >
            <v-list-item-content>
              <v-list-item-title v-text="session.name" />
            </v-list-item-content>
            <v-list-item-action>
              <v-checkbox :input-value="session.selected" color="accent" />
            </v-list-item-action>
          </v-list-item>
        </template>
      </v-list>
      <div
        v-else
        class="text-center mt-5 mb-5"
        v-text="$t('animation.error.noResultAddSession')"
      />
    </template>

    <div
      v-else
      class="text-center mt-10 mb-5"
      v-text="$t('animation.error.emptyAddSession')"
    />

    <template #footer>
      <v-spacer />
      <v-btn
        color="secondary"
        class="ml-5"
        outlined
        @click="close"
        v-text="$t('general.cancel')"
      />
      <v-btn
        :loading="loading"
        :disabled="!selectedSessionIdList.length"
        color="accent"
        class="ml-5"
        @click="create"
        v-text="$t('general.add')"
      />
    </template>
  </ag-modal-container>
</template>

<script>
import AgModalContainer from 'src/components/common/AgModalContainer'
import { mapActions, mapGetters } from 'vuex'
import Helpers from 'src/utils/helpers'

export default {
  name: 'AddSessionsContainer',
  components: {
    AgModalContainer,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    loading: false,
    selectedSessionIdList: [],
    search: '',
  }),
  computed: {
    ...mapGetters('animation', {
      openableSessionList: 'openableSessionList',
    }),
    sessionList () {
      return this.openableSessionList
        .filter(session => Helpers.localeIncludes(session.name, this.search))
        .sort((a, b) => b.dateCreate.localeCompare(a.dateCreate))
        .map(session => ({
          ...session,
          selected: this.selectedSessionIdList.includes(session.id),
        }))
    },
  },
  methods: {
    ...mapActions('animation', {
      openSessionList: 'openSessionList',
    }),
    close () {
      this.selectedSessionIdList = []
      this.$emit('update:visible', false)
    },
    create () {
      if (this.selectedSessionIdList.length) {
        this.openSessionList(this.selectedSessionIdList)
        this.close()
      }
    },
    toggleSessionSelect (sessionId) {
      if (this.selectedSessionIdList.includes(sessionId)) {
        this.selectedSessionIdList = this.selectedSessionIdList
          .filter(id => id !== sessionId)
      }
      else {
        this.selectedSessionIdList.push(sessionId)
      }
    },
  },
}
</script>
